export default __webpack_public_path__ + "static/media/Facebook.ee0523e2.svg";